/**
 *
 * ListFilters
 *
 */

import FormControl from '@material-ui/core/FormControl'
// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import React from 'react'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  inputStyle: {
    display: 'flex',
    border: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    borderRadius: '4px',
    '&:focus-within': {
      border: `1px solid ${theme.inputField.inputBorderActive}`,
    },
    '& > div::before': {
      borderRadius: 4,
      border: 'none',
    },
    '& > div': {
      '&::after': {
        borderBottom: 'none !important',
      },
      '&:hover': {
        '&::before': {
          borderBottom: 'none !important',
        },
        '&::after': {
          borderBottom: 'none !important',
        },
      },
    },
    '& input': {
      padding: '9px 10px 10px 10px',
      fontSize: '14px',
      lineHeight: '1',
      borderRadius: 4,
      '&:focus': {
        backgroundColor: theme.inputField.inputBGColorActive,
      },
    },
  },
})

/* eslint-disable react/prefer-stateless-function */
class InputTwo extends React.Component {
  render() {
    const { className, classes, ContainterStyle, ...rest } = this.props
    return (
      <FormControl style={ContainterStyle} className={`${classes.root} ${className}`}>
        <div className={classes.wrapper}>
          <TextField className={classes.inputStyle} {...rest} />
        </div>
      </FormControl>
    )
  }
}

InputTwo.defaultProps = {}

const InputTwoExport = withStyles(styles)(InputTwo)
InputTwoExport.displayName = 'InputTwo'
export default InputTwoExport
